import './datepicker/datepicker-pt.js';
import './parsley/pt-br.js';
import './parsley/pt-pt.js';
import './languageformat/languageformat.js';
